<template>
  <el-upload
    class="upload-demo fl"
    drag
    :action="actionUrl"
    accept="image/*"
    :http-request="fnUploadRequest"
    multiple>
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将
      <span v-if="certType == 1">
                营业执照
              </span>
      <span v-else-if="certType == 0">
               身份证正面
              </span>
      <span v-else>
               文件
              </span>
      拖到此处，或<em>点击上传</em></div>
    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
    <div v-if="picUrl != ''"  class="img-box">
      <img style="max-width: 170px" :src="picUrl"/>
    </div>
    <el-progress  v-show="upload.showProgress" class="upload-cert-progress" :text-inside="true" :stroke-width="18"
                 :percentage="upload.uploadPercent"></el-progress>
    <el-tag v-show="upload.showSectionFileName" type="gray">{{downloadUrl}}</el-tag>
  </el-upload>
</template>

<script>
  import {Message} from "element-ui";
    export default {
      name: "upload",
      props: {
        actionUrl: {
          type: String,
          default: ''
        },
        certType:{
          type: Number,
          default: 2
        },
        picUrl:{
          type: String,
          default: ''
        }
      },
      data() {
        return {
          upload:{
            uploadUrl:'',
            //控制上传次数
            i:0,
            j:0,
            showProgress:false,
            uploadPercent: 0,
            showSectionFileName:false
          },
          downloadUrl:''
        }
      },
      methods: {
        fnUploadRequest(f) {
          var _this = this;
          var param = new FormData(); //创建form对象
          param.append('file', f.file);//通过append向form对象添加数据
          var xhr = new XMLHttpRequest();
          xhr.open("post", f.action, true);
          xhr.setRequestHeader("authorization",_this.$store.state.user ? _this.$store.state.user.token : null);
          xhr.upload.addEventListener("progress", _this.progressFunction, false); //监听上传进度
          xhr.onload = function () {
            _this.upload.uploadPercent = 100;
            _this.downloadUrl = JSON.parse(xhr.response).result.url;
            _this.$emit('getUrl', _this.downloadUrl)
            _this.$message({
              message: '恭喜你，上传成功!',
              type: 'success'
            });
          };
          xhr.send(param);
          xhr.onreadystatechange = function(){
            if(xhr.status == 401){
              window.location.href = "/";
            }else if(xhr.status != 200){
              //console.log(xhr)
              Message.error(xhr.statusText)
            }

          }
        },
        progressFunction: function (fun) {
          if (this.upload.i == 0) { //控制上传中状态只执行一次上传
            this.upload.showProgress = true;
            this.upload.i = 1;
          }
          if (fun.total != 0) {
            this.upload.uploadPercent = parseInt((fun.loaded / fun.total).toFixed(2) * 100);
          }
          if(this.upload.uploadPercent >= 90){
            this.upload.uploadPercent = 90;
          }
        }
      }
    }
</script>

<style scoped>
.img-box{
  width: 100%;
  height: 110px;
  line-height: 180px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999;
}
@media screen and (max-width: 768px) {
  .el-upload {
    width: 100%;
  }
  /deep/.el-upload .el-upload-dragger {
    width: 100%!important;
  }
}
</style>
